import * as React from 'react'
import * as Router from 'react-router-dom'

import { usePost, usePosts } from '../api/request'

import { Button, LinkButton } from './Button'
import { PostArticle, PostLoading, PostNotFound, PostSearchBar } from './Post'

function PostWrapper(props: { children: React.ReactNode }) {
  return (
    <main className="h-auto max-w-6xl mx-auto lg:px-12 md:px-8 sm:px-6 px-4 pt-6 space-y-2 my-16">
      {props.children}
    </main>
  )
}

function MainPartEarlier(props: { onClick: React.MouseEventHandler<HTMLButtonElement> }) {
  return (
    <div className="flex-row space-x-2 px-2">
      <Button onClick={props.onClick}>更早的茶后谈</Button>
    </div>
  )
}

function MainPartEarlierLater(props: { prev: number, next: number }) {
  const { prev, next } = props
  return (
    <div className="flex-row space-x-2 px-2">
      {prev > 0 ? <LinkButton to={'/' + prev}>上一期</LinkButton> : null}
      <LinkButton to={'/' + next}>下一期</LinkButton>
    </div>
  )
}

function MainPartNotFound() {
  const history = Router.useHistory()

  return (
    <div className="flex-row space-x-2 px-2">
      <Button onClick={() => history.goBack()}>返回</Button>
    </div>
  )
}

export function Main() {
  const [nextPost, until, posts, { wait, refresh, append, query }] = usePosts()

  const submit = React.useCallback((text: string) => text ? query(text) : refresh(), [])

  const history = Router.useHistory()

  React.useEffect(() => {
    const callback = (e: KeyboardEvent) => {
      if (nextPost > 0 && e.code === 'KeyE' && e.ctrlKey) {
        const token = localStorage.getItem('chahoutan_token') ?? ''
        const newToken = !token ? prompt('请输入 token') : e.shiftKey ? prompt('请确认 token', token) : token
        if (newToken) {
          localStorage.setItem('chahoutan_token', newToken)
          history.push('/' + nextPost + '/edit')
        }
        e.preventDefault()
      }
    }
    document.addEventListener('keydown', callback)
    return () => document.removeEventListener('keydown', callback)
  })

  return (
    <PostWrapper>
      <PostSearchBar onLoading={wait} onSubmit={submit} />
      {posts.map((post) => (<PostArticle key={post.revision} editors={post.editors} post={post} />))}
      {until > 0 ? <MainPartEarlier onClick={append} /> : null}
      {until < 0 ? <PostLoading /> : null}
      {until < 0 ? <PostLoading /> : null}
      {until < 0 ? <PostLoading /> : null}
    </PostWrapper>
  )
}

export function MainSingle() {
  const params = Router.useParams<{ id: string }>()

  const history = Router.useHistory()

  const id = parseInt(params.id)

  const [posts] = usePost(id)

  React.useEffect(() => {
    const callback = (e: KeyboardEvent) => {
      if (posts && e.code === 'KeyE' && e.ctrlKey) {
        const token = localStorage.getItem('chahoutan_token') ?? ''
        const newToken = !token ? prompt('请输入 token') : e.shiftKey ? prompt('请确认 token', token) : token
        if (newToken) {
          localStorage.setItem('chahoutan_token', newToken)
          history.push('/' + id + '/edit')
        }
        e.preventDefault()
      }
    }
    document.addEventListener('keydown', callback)
    return () => document.removeEventListener('keydown', callback)
  })

  if (posts === null) {
    return (
      <PostWrapper>
        <PostLoading />
      </PostWrapper>
    )
  }
  if (posts.length === 0) {
    return (
      <PostWrapper>
        <PostNotFound />
        <MainPartNotFound />
      </PostWrapper>
    )
  }
  const post = posts[0], isRevision = post.type === 'revision'
  const editors = isRevision ? [] : post.editors
  return (
    <PostWrapper>
      <PostArticle key={post.revision} editors={editors} post={post} />
      <MainPartEarlierLater prev={id - 1} next={id + 1} />
    </PostWrapper>
  )
}
